/**
 * Agrupa los datos sin procesar en grupos según tipos de factura
 */
function groupData(rawData, currencySymbol = '$') {
  const data = JSON.parse(JSON.stringify(rawData));

  const results = {};

  const groups = [
    { id: 'FCF', title: 'FACTURA CONSUMIDOR FINAL', rows: [] },
    { id: 'CCF', title: 'COMPROBANTE DE CRÉDITO FISCAL', rows: [] },
    { id: 'FNS', title: 'FACTURA SUJETO EXCLUIDO', rows: [] },
    { id: 'FEX', title: 'FACTURA DE EXPORTACIÓN', rows: [] },
    { id: 'DNC', title: 'NOTA DE CRÉDITO', rows: [] },
    { id: 'DND', title: 'NOTA DE DÉBITO', rows: [] },
    { id: 'CDD', title: 'COMPROBANTE DE DONACIÓN', rows: [] },
    { id: 'DNR', title: 'NOTA DE REMISIÓN', rows: [] },
    { id: 'CAP', title: 'ANTICIPOS', rows: [] },
    { id: 'RCIB', title: 'ABONOS', rows: [] },
  ];

  const expensesGroup = { id: 'EXPENSES', title: 'EGRESOS', rows: [], isExpense: true };
  const othersGroup = { id: '', title: 'OTROS', rows: [] };

  const sortedData = [...data].sort((a, b) => a.ID_Invoice.localeCompare(b.ID_Invoice));

  sortedData.forEach(item => {
    
    item.Gravada = parseNumber(item.PriceNotIva, currencySymbol);
    item.PriceNotIva = parseNumber(item.InvoiceTotalExenta, currencySymbol);
    item.Iva = parseNumber(item.Iva, currencySymbol);
    item.Total = parseNumber(item.Total, currencySymbol);
    item.InvoiceIvaRete1 = parseNumber(item.InvoiceIvaRete1, currencySymbol);
    item.abonado = parseNumber(item.abonado, currencySymbol);
    item.TotalSale = parseNumber(item.TotalSale, currencySymbol);

    if (item.ID_Invoice.includes('DNC') || item.InvoiceStatusDescription.includes('INVALIDADO')) {
      expensesGroup.rows.push(item);
      return;
    }
    const group = groups.find(g => item.ID_Invoice.includes(g.id));
    if (group) {
      group.rows.push(item);
    } else {
      othersGroup.rows.push(item);
    }
  });

  if (expensesGroup.rows.length > 0) results.expenses = expensesGroup;
  
  if (othersGroup.rows.length > 0) groups.push(othersGroup);

  results.regular = groups;

  return results;
}

/**
 * Convierte el valor string de un numero a float, removiendo el símbolo de moneda
 */
function parseNumber(value, customSymbol = '$') {
  if (typeof value !== 'string') return value;

  // Define common currency symbols
  const currencySymbols = ['$', '€', '£', '¥', '₹', '₽', '₿', '₫', customSymbol].filter(symbol => symbol !== '');
  
  // Create regex pattern to match any of the currency symbols, commas, and whitespace
  const pattern = new RegExp(`[${currencySymbols.join('')},\\s]`, 'g');
  
  // Replace matched characters with empty string
  return parseFloat(value.replace(pattern, '')) || 0;
}

function formatCurrency(number, currencySymbol = '$') {
  return `${currencySymbol}${parseFloat(number).toFixed(2)}`
}

/**
 * Calcula totales por cada columna numérica de un grupo
 */
function calculateGroupColumnTotals(group) {
  let columnTotals = {
    Gravada: 0,
    PriceNotIva: 0,
    Iva: 0,
    Total: 0,
    InvoiceIvaRete1: 0,
  };

  if (group.isExpense) {
    columnTotals.Devolucion = 0;
  }

  group.rows.forEach(row => {
    columnTotals.Gravada += row.Gravada || 0;
    columnTotals.PriceNotIva += row.PriceNotIva || 0;
    columnTotals.Iva += row.Iva || 0;
    columnTotals.InvoiceIvaRete1 += row.InvoiceIvaRete1 || 0;
    columnTotals.Total += row.Total || 0;

    if (group.isExpense) {
      let value = 0;

      if (row.sum === 1 && row.abonado === 0) {
        value = row.Total;
      } else {
        value = row.abonado;
      }

      columnTotals.Devolucion += Math.abs(value);
    }
  });


  return columnTotals;
}

/**
 * Calcula subtotales de grupo por forma de pago
 */
function calculateGroupPaymentFormTotals(group) {
  let paymentFormTotals = {
    subtotalContado: 0,
    subtotalCheque: 0,
    subtotalTransferencia: 0,
    subtotalCredito: 0,
    subtotalTarjeta: 0,
    subtotalOtros: 0,
  };

  group.rows.forEach(item => {
    
    const descPayment = item.Codigo || '';
    const invoiceStatus = item.InvoiceStatusDescription || '';
    // const totalValue = parseFloat(String(item.Total || '0').replace(/[$,]/g, '')) || 0;
    let totalValue = item.Total;

    if (group.isExpense ) {
      totalValue = item.sum === 1 && item.abonado === 0 
          ? Math.abs(item.Total)
          : Math.abs(item.abonado);
    }

    // const totalSaleValue = parseFloat(item.TotalSale || 0) || 0;
    const totalSaleValue = item.TotalSale;

    if (descPayment === '01') paymentFormTotals.subtotalContado += totalSaleValue;
      else if (descPayment === '04') paymentFormTotals.subtotalCheque += totalSaleValue;
      else if (descPayment === '05') paymentFormTotals.subtotalTransferencia += totalSaleValue;
      else if (invoiceStatus === 'Crédito') paymentFormTotals.subtotalCredito += totalValue;
      else if (['02', '03'].includes(descPayment))
        paymentFormTotals.subtotalTarjeta += totalSaleValue;
      else paymentFormTotals.subtotalOtros += totalSaleValue;
  });


  return paymentFormTotals;
}

/**
 * Calcula totales globales por columna numérica 
 */
function calculateGlobalColumTotals(groups, currencySymbol = '$') {
  let totals = {
    Gravada: 0,
    PriceNotIva: 0,
    Iva: 0,
    Total: 0,
    InvoiceIvaRete1: 0,
  };

  groups.forEach(group => {
    const columnTotals = calculateGroupColumnTotals(group, currencySymbol);
    group.columnTotals = columnTotals;

    totals.Gravada += columnTotals.Gravada;
    totals.PriceNotIva +=  columnTotals.PriceNotIva;
    totals.Iva += columnTotals.Iva;
    totals.InvoiceIvaRete1 += columnTotals.InvoiceIvaRete1;
    totals.Total += columnTotals.Total;

    if (group.isExpense) {
      totals.Devolucion = 0;
    }

    if (group.isExpense) {
      totals.Devolucion += columnTotals.Devolucion
    }
  })

  return totals;
}

/**
 * Calcula totales globales por columna 
 */
function calculateGlobalPaymentFormTotals(groups, currencySymbol = '$') {
  let totals = {
    subtotalContado: 0,
    subtotalCheque: 0,
    subtotalTransferencia: 0,
    subtotalCredito: 0,
    subtotalTarjeta: 0,
    subtotalOtros: 0,
  };

  groups.forEach(group => {
    const paymentFormTotals = calculateGroupPaymentFormTotals(group, currencySymbol);

    group.paymentFormTotals = paymentFormTotals

    totals.subtotalContado += paymentFormTotals.subtotalContado;
    totals.subtotalCheque += paymentFormTotals.subtotalCheque;
    totals.subtotalTransferencia += paymentFormTotals.subtotalTransferencia;
    totals.subtotalCredito += paymentFormTotals.subtotalCredito;
    totals.subtotalTarjeta += paymentFormTotals.subtotalTarjeta;
    totals.subtotalOtros += paymentFormTotals.subtotalOtros;
  })

  return totals;
}

function calculateTotals(groups) {
  const columnTotals = calculateGlobalColumTotals(groups);
  const paymentFormTotals = calculateGlobalPaymentFormTotals(groups);

  return {
    columnTotals,
    paymentFormTotals,
  };
}

function formatDateToDDMMYYYYStart(date) {
  if (/^\d{2}\/\d{2}\/\d{4}$/.test(date)) {
    return date;
  }
  const d = new Date(date);
  if (isNaN(d.getTime())) {
    return 'Fecha inválida';
  }
  const day = d.getDate().toString().padStart(2, '0');
  const month = (d.getMonth() + 1).toString().padStart(2, '0'); // Los meses van de 0 (enero) a 11 (diciembre)
  const year = d.getFullYear();

  return `${day}/${month}/${year}`;
}

function formatDateToDDMMYYYYEnd(date) {
  if (/^\d{2}\/\d{2}\/\d{4}$/.test(date)) {
    return date;
  }
  const d = new Date(date);
  if (isNaN(d.getTime())) {
    return 'Fecha inválida';
  }
  const day = d.getDate().toString().padStart(2, '0');
  const month = (d.getMonth() + 1).toString().padStart(2, '0'); // Los meses van de 0 (enero) a 11 (diciembre)
  const year = d.getFullYear();

  return `${day}/${month}/${year}`;
}

/**
 * Genera PDF con jsPDF y jsPDF-AutoTable; todas las tablas ocupan ancho completo (respetando márgenes)
 */
export default async (rawData, dates) => {
  const jsPDF = (await import('jspdf')).jsPDF || (await import('jspdf')).default;
  const autoTable = (await import('jspdf-autotable')).default;

  const doc = new jsPDF('p', 'pt', 'letter');
  const marginLeft = 15;
  const marginRight = 15;
  const pageWidth = doc.internal.pageSize.getWidth();
  const usablePageWidth = pageWidth - marginLeft - marginRight;

  const spacingBeforeDetailedTotals = 0;
  const spacingAfterDetailedTotals = 30;

  let cursorY = 30;

  const businessName = JSON.parse( localStorage.getItem( 'user' ))?.business || ''
  const branchName = JSON.parse(localStorage.getItem('branch'))?.BranchName || '';
  const title = (businessName + ' - ' + branchName).toUpperCase();
  autoTable(doc, {
    startY: cursorY,
    margin: { left: marginLeft, right: marginRight },
    head: [[title]],
    styles: { fontSize: 13, halign: 'right', valign: 'middle' },
    headStyles: { fillColor: 255, textColor: 0, fontStyle: 'bold', halign: 'center' },
    theme: 'plain',
    didDrawPage: data => {
      cursorY = data.cursor.y + spacingBeforeDetailedTotals;
    },
    rowPageBreak: 'avoid',
    showHead: 'everyPage',
  });

  cursorY += 10;

  const dateRange =  `MOVIMIENTO DE VENTAS DEL ${formatDateToDDMMYYYYStart(dates.start)} AL ${formatDateToDDMMYYYYEnd(dates.end)}`; 

  autoTable(doc, {
    startY: cursorY,
    margin: { left: marginLeft, right: marginRight },
    head: [[dateRange]],
    styles: { fontSize: 10, halign: 'right', valign: 'middle' },
    headStyles: { fillColor: 255, textColor: 0, fontStyle: 'bold', halign: 'center' },
    theme: 'plain',
    didDrawPage: data => {
      cursorY = data.cursor.y + spacingBeforeDetailedTotals;
    },
    rowPageBreak: 'avoid',
    showHead: 'everyPage',
  });

  cursorY += 20;

  // agrupar datos por tipo de comprobante
  const groupedData = groupData(rawData);

  // calcular totales de grupo y globales
  const globalTotals = calculateTotals(groupedData.regular)

  // Generar tablas de ingresos
  const tableColumns = [
    { header: 'Correlativo', dataKey: 'ID_Invoice' },
    { header: 'Forma', dataKey: 'DescPaymentType' },
    { header: 'Fecha', dataKey: 'InvoiceDate' },
    { header: 'Nombre Cliente', dataKey: 'InvoiceName' },
    { header: 'Valor Gravado', dataKey: 'Gravada' },
    { header: 'Valor Exento', dataKey: 'PriceNotIva' },
    { header: 'IVA', dataKey: 'Iva' },
    { header: 'Ret. IVA', dataKey: 'InvoiceIvaRete1' },
    { header: 'Total', dataKey: 'Total' },
    { header: 'Usuario', dataKey: 'UserName' }
  ];

  for (const group of groupedData.regular) {
    if (!group.rows || group.rows.length === 0) continue;

    if (cursorY > doc.internal.pageSize.getHeight() - 200) {
      doc.addPage();
      cursorY = 30;
    }

    doc.setFontSize(10);
    doc.setFont(undefined, 'bold');
    doc.text(group.title, marginLeft, cursorY);
    cursorY += 10;

    const bodyRows = group.rows.map(row => {
      const DescPaymentType = row.InvoiceStatusDescription.toLowerCase() === 'invalidado' 
        ? 'INVALIDADO'
        : row.DescPaymentType;
        
      return {
        ID_Invoice: row.ID_Invoice,
        DescPaymentType,
        InvoiceDate: row.InvoiceDate,
        InvoiceName: row.InvoiceName,
        Gravada: formatCurrency(row.Gravada),
        PriceNotIva: formatCurrency(row.PriceNotIva),
        Iva: formatCurrency(row.Iva),
        Total: formatCurrency(row.Total),
        InvoiceIvaRete1: formatCurrency(row.InvoiceIvaRete1),
        UserName: row.UserName,
      }
    });

    // Fila totales de columna
    const totalsRow = [
      'Totales', '', '', '',
      formatCurrency(group.columnTotals.Gravada),
      formatCurrency(group.columnTotals.PriceNotIva),
      formatCurrency(group.columnTotals.Iva),
      formatCurrency(group.columnTotals.InvoiceIvaRete1),
      formatCurrency(group.columnTotals.Total),
      ''
    ];

    const finalBodyRows = [
      ...bodyRows.map(row => tableColumns.map(col => row[col.dataKey])),
      totalsRow
    ];

    autoTable(doc, {
      startY: cursorY,
      margin: { left: marginLeft, right: marginRight },
      head: [tableColumns.map(col => col.header)],
      body: finalBodyRows,
      styles: { fontSize: 8, halign: 'right', valign: 'middle', cellPadding: 2, },
      headStyles: { fillColor: 255, textColor: 0, fontStyle: 'bold', halign: 'center' },
      columnStyles: {
        0: {
          halign: 'center',
        },
        1: {
          halign: 'center',
        },
        2: {
          halign: 'center',
        },
        3: {
          halign: 'center',
        },
      },
      theme: 'plain',
      didDrawPage: data => {
        cursorY = data.cursor.y + spacingBeforeDetailedTotals;
      },
      rowPageBreak: 'avoid',
      showHead: 'everyPage',
      didParseCell: function (data) {
        if (data.row.index === finalBodyRows.length - 1) {
          data.cell.styles.fontStyle = 'bold';
          data.cell.styles.fillColor = 255;
          data.cell.styles.textColor = 0;
        }
      }
    });

    // Tabla totales de forma de pago de grupo
    if (cursorY + 70 > doc.internal.pageSize.getHeight()) {
      doc.addPage();
      cursorY = 30;
    }
    cursorY += spacingBeforeDetailedTotals;

    const paymentFormTotalsRows = [
      [
        'Subtotal contado', formatCurrency(group.paymentFormTotals.subtotalContado), 
        'Subtotal cheque', formatCurrency(group.paymentFormTotals.subtotalCheque), 
        'Subtotal transferencia', formatCurrency(group.paymentFormTotals.subtotalTransferencia)
      ],
      [
        'Subtotal crédito', formatCurrency(group.paymentFormTotals.subtotalCredito), 
        'Subtotal tarjeta', formatCurrency(group.paymentFormTotals.subtotalTarjeta), 
        'Subtotal otros', formatCurrency(group.paymentFormTotals.subtotalOtros)
      ]
    ];

    autoTable(doc, {
      startY: cursorY,
      margin: { left: marginLeft, right: marginRight },
      body: paymentFormTotalsRows,
      styles: { fontSize: 8, fontStyle: 'bold' },
      tableLineColor: 100,
      tableLineWidth: 1,
      theme: 'plain',
      tableWidth: usablePageWidth,
      columnStyles: {
        0: { textColor: 50 },
        1: {  halign: 'right' },
        2: { textColor: 50 },
        3: {  halign: 'right' },
        4: { textColor: 50 },
        5: {  halign: 'right' },
      },
      didDrawPage: data => {
        cursorY = data.cursor.y + spacingAfterDetailedTotals;
      }
    });
  }

  // Tabla de egresos
  const group = groupedData.expenses;
  let totalEgresos = 0;

  if (group && group.rows.length ) {
    const expensesTableColumns = [
      { header: 'Correlativo', dataKey: 'ID_Invoice' },
      { header: 'Forma', dataKey: 'DescPaymentType' },
      { header: 'Fecha', dataKey: 'InvoiceDate' },
      { header: 'Nombre Cliente', dataKey: 'InvoiceName' },
      { header: 'Valor Gravado', dataKey: 'Gravada' },
      { header: 'Valor Exento', dataKey: 'PriceNotIva' },
      { header: 'IVA', dataKey: 'Iva' },
      { header: 'Total', dataKey: 'Total' },
      { header: 'Devolución', dataKey: 'Devolucion' },
      { header: 'Usuario', dataKey: 'UserName' }
    ];

    const expensesTotals = calculateTotals([group])
    totalEgresos = expensesTotals.columnTotals.Devolucion

    if (cursorY > doc.internal.pageSize.getHeight() - 200) {
      doc.addPage();
      cursorY = 30;
    }

    doc.setFontSize(10);
    doc.setFont(undefined, 'bold');
    doc.text(group.title, marginLeft, cursorY);
    cursorY += 10;

    const bodyRows = group.rows.map(row => {
      const DescPaymentType = row.InvoiceStatusDescription.toLowerCase() === 'invalidado' 
        ? 'INVALIDADO'
        : row.DescPaymentType;

      const Devolucion = row.sum === 1 && row.abonado === 0 
        ? formatCurrency(Math.abs(row.Total))
        : formatCurrency(Math.abs(row.abonado));
        
      return {
        ID_Invoice: row.ID_Invoice,
        DescPaymentType,
        InvoiceDate: row.InvoiceDate,
        InvoiceName: row.InvoiceName,
        Gravada: formatCurrency(row.Gravada),
        PriceNotIva: formatCurrency(row.PriceNotIva),
        Iva: formatCurrency(row.Iva),
        Total: formatCurrency(Math.abs(row.Total)),
        Devolucion,
        InvoiceIvaRete1: formatCurrency(row.InvoiceIvaRete1),
        UserName: row.UserName,
      }
    });

    // Fila totales de columna de egreso
    const totalsRow = [
      'Totales', '', '', '',
      formatCurrency(group.columnTotals.Gravada),
      formatCurrency(group.columnTotals.PriceNotIva),
      formatCurrency(group.columnTotals.Iva),
      formatCurrency(group.columnTotals.Total),
      formatCurrency(group.columnTotals.Devolucion),
      ''
    ];

    const finalBodyRows = [
      ...bodyRows.map(row => expensesTableColumns.map(col => row[col.dataKey])),
      totalsRow
    ];

    autoTable(doc, {
      startY: cursorY,
      margin: { left: marginLeft, right: marginRight },
      head: [expensesTableColumns.map(col => col.header)],
      body: finalBodyRows,
      styles: { fontSize: 8, halign: 'right', valign: 'middle', cellPadding: 2 },
       columnStyles: {
        0: {
          halign: 'center',
        },
        1: {
          halign: 'center',
        },
        2: {
          halign: 'center',
        },
        3: {
          halign: 'center',
        },
      },
      headStyles: { fillColor: 255, textColor: 0, fontStyle: 'bold', halign: 'center' },
      theme: 'plain',
      didDrawPage: data => {
        cursorY = data.cursor.y + spacingBeforeDetailedTotals;
      },
      rowPageBreak: 'avoid',
      showHead: 'everyPage',
      didParseCell: function (data) {
        if (data.row.index === finalBodyRows.length - 1) {
          data.cell.styles.fontStyle = 'bold';
          data.cell.styles.fillColor = 255;
          data.cell.styles.textColor = 0;
        }
      }
    });
  }
  
  // Totales globales
  if (cursorY + 70 > doc.internal.pageSize.getHeight()) {
    doc.addPage();
    cursorY = 30;
  }

  cursorY += 30;
  doc.setFontSize(10);
  doc.setFont(undefined, 'bold');
  doc.text('TOTAL GLOBAL', marginLeft, cursorY);
  cursorY += 15;

  const { paymentFormTotals } = globalTotals;
  const subTotal = paymentFormTotals.subtotalContado
        + paymentFormTotals.subtotalTarjeta
        + paymentFormTotals.subtotalTransferencia
        + paymentFormTotals.subtotalCheque;
  
  const total = subTotal 
    + paymentFormTotals.subtotalCredito 
    + paymentFormTotals.subtotalOtros 
    - totalEgresos;

  const totalRows = [
    [
      'Total contado', formatCurrency(paymentFormTotals.subtotalContado), 
      'Total cheque', formatCurrency(paymentFormTotals.subtotalCheque), 
      'Total transferencia', formatCurrency(paymentFormTotals.subtotalTransferencia)
    ],
    [
      'Total tarjeta', formatCurrency(paymentFormTotals.subtotalTarjeta), 
      'Total crédito', formatCurrency(paymentFormTotals.subtotalCredito), 
      'Total otros', formatCurrency(paymentFormTotals.subtotalOtros)
    ],
    [
      'Subtotal', formatCurrency(subTotal),
      'Total egresos', formatCurrency(totalEgresos),
      'Total', formatCurrency(total),
    ],
  ];

  autoTable(doc, {
    startY: cursorY,
    margin: { left: marginLeft, right: marginRight },
    body: totalRows,
    styles: { fontSize: 8, fontStyle: 'bold' },
    tableLineColor: 100,
    tableLineWidth: 1,
    theme: 'plain',
    tableWidth: usablePageWidth,
    columnStyles: {
      0: { textColor: 50 },
      1: {  halign: 'right' },
      2: { textColor: 50 },
      3: {  halign: 'right' },
      4: { textColor: 50 },
      5: {  halign: 'right' },
    },
    didDrawPage: data => {
      cursorY = data.cursor.y + spacingAfterDetailedTotals;
    }
  });


  const pdfBlob = doc.output('blob');
  const blobUrl = URL.createObjectURL(pdfBlob);
  window.open(blobUrl);
};
